<template>
  <div :class="['organism our-team', 'container-' + organism.containerWidth, organism.removeMargin]">
    <div class="w-full px-8 pt-12 bg-bc-gray mb-14">
      <h2 class="mx-auto mb-6 text-4xl font-semibold max-w-7xl font-archer">
        Select a department
      </h2>
      <ul class="flex flex-col flex-wrap pb-6 mx-auto sm:flex-row max-w-7xl">
        <li v-for="department in teamDetails.departments">
          <a
            :href="'#department-' + department.department"
            class="block mr-8 underline text-new-blue text-[15px] font-arial mb-6"
            >{{ department.department }}</a
          >
        </li>
      </ul>
    </div>
    <div
      v-for="department in teamDetails.departments"
      class="mx-auto shadow-md bg-bc-gray max-w-7xl mb-14"
    >
      <OrganismsHeadingTransition
        :organism="{ title1: department.department, arrow: true }"
        class="max-w-7xl"
        :id="'department-' + department.department"
      />
      <div
        class="mx-auto w-fit grid grid-cols-[272px] md:grid-cols-[repeat(2,_272px)] lg:grid-cols-[repeat(3,_272px)] xl:grid-cols-[repeat(4,_272px)] gap-x-4 gap-y-8 max-w-full pt-7 pb-20 px-8 md:px-0"
      >
        <div
          v-for="teamMember in department.teamMembers"
          class="self-start max-w-full bg-white border shadow-md border-neutral-300"
        >
          <img
            :src="teamMember.photo.sourceUrl"
            :alt="teamMember.name + ' headshot'"
            class="w-full h-auto object-contain"
            loading="lazy"
            decoding="async"
          />
          <div class="p-6">
            <div class="mb-3 font-bold font-ubuntu text-bc-dark-blue">
              {{ teamMember.name }}
            </div>
            <div class="text-base text-gray-500 font-arial">
              {{ teamMember.position }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.our-team {
}
</style>

<script setup>
import { useQuery } from "@vue/apollo-composable";
import { GET_TEAM_DETAILS } from "~/graphql/GetTeamDetails";
const { result } = useQuery(GET_TEAM_DETAILS);

const teamDetails = computed(() => result?.value?.page?.teamDetails ?? []);

const props = defineProps({
  organism: Object,
});

onMounted(() => {
  if (props.organism.containerWidth === "full-width") {
    addFullWidthSupport();
  }
});
</script>
